import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "home-beneficiary-page" }
const _hoisted_2 = { class: "cashbook-sidebar" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "sidebar-ym-selector" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "ym-value" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "sidebar-title-badge" }
const _hoisted_9 = { class: "sidebar-summary" }
const _hoisted_10 = { class: "summary-item" }
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "summary-item" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "summary-item" }
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "sidebar-filter" }
const _hoisted_17 = { class: "filter-header" }
const _hoisted_18 = { class: "filter-buttons" }
const _hoisted_19 = { class: "sidebar-filter" }
const _hoisted_20 = { class: "filter-header" }
const _hoisted_21 = { class: "search-input-wrapper" }
const _hoisted_22 = { class: "page-main" }
const _hoisted_23 = {
  key: 0,
  class: "loading-state"
}
const _hoisted_24 = {
  key: 1,
  class: "beneficiary-list-section"
}
const _hoisted_25 = { class: "section-header" }
const _hoisted_26 = { class: "header-title" }
const _hoisted_27 = { class: "title-icon" }
const _hoisted_28 = { class: "title-count" }
const _hoisted_29 = { class: "header-actions" }
const _hoisted_30 = ["disabled", "title"]
const _hoisted_31 = { class: "current-month-label" }
const _hoisted_32 = {
  key: 0,
  class: "beneficiary-table"
}
const _hoisted_33 = { class: "col-no" }
const _hoisted_34 = { class: "patient-name" }
const _hoisted_35 = { class: "patient-icon" }
const _hoisted_36 = { class: "text-center" }
const _hoisted_37 = { class: "date-text" }
const _hoisted_38 = { class: "text-center" }
const _hoisted_39 = { class: "date-text" }
const _hoisted_40 = { class: "text-center" }
const _hoisted_41 = { class: "service-info" }
const _hoisted_42 = { class: "text-center col-action" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { class: "text-center col-action" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { class: "text-center col-action" }
const _hoisted_47 = ["onClick", "disabled"]
const _hoisted_48 = {
  key: 0,
  class: "detail-row"
}
const _hoisted_49 = { colspan: "9" }
const _hoisted_50 = { class: "inline-detail" }
const _hoisted_51 = {
  key: 0,
  class: "detail-loading"
}
const _hoisted_52 = {
  key: 1,
  class: "monthly-summary"
}
const _hoisted_53 = { class: "month-header" }
const _hoisted_54 = { class: "month-label" }
const _hoisted_55 = { class: "month-stats" }
const _hoisted_56 = { class: "stat-item" }
const _hoisted_57 = { class: "stat-value" }
const _hoisted_58 = { class: "stat-item" }
const _hoisted_59 = { class: "stat-value" }
const _hoisted_60 = {
  key: 0,
  class: "month-caregivers"
}
const _hoisted_61 = {
  key: 2,
  class: "empty-text"
}
const _hoisted_62 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_63 = { class: "empty-icon" }

import { ref, computed, onMounted, watch, inject, type Ref } from 'vue';
import { useStore } from 'vuex';
import { homeScheduleApi } from '@/services/api';
import LtcsRequestModal from '@/components/member/schedule/LtcsRequestModal.vue';
import BeneficiaryCalendarModal from '@/components/member/schedule/BeneficiaryCalendarModal.vue';
import { useMemberYearMonthOptional } from '@/composables/useMemberYearMonth';

// MemberDetailLayout에서 provide한 값들
interface Beneficiary {
  patient_code: string;
  patient_name: string;
  first_service_date: string;
  last_service_date: string;
  total_months?: number;
  service_days?: number;
  total_minutes?: number;
}

interface MonthlySummary {
  year_month: string;
  service_days: number;
  caregiver_count: number;
  caregivers: string;
  total_minutes: number;
  suga_types: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeBeneficiaryPage',
  setup(__props) {

const injectedMemberData = inject<Ref<any>>('memberData', ref(null));
const injectedBizGubun = inject<Ref<string>>('selectedBizGubun', ref(''));

const store = useStore();
const memberCode = computed(() => injectedMemberData.value?.m_code || store.state.user?.m_code);
const bizGubun = computed(() => injectedBizGubun.value || store.state.user?.m_biz_gubun);

const isLoading = ref(true);
const isPdfLoading = ref(false);
const monthlySummaryLoading = ref(false);
const sidebarPosition = ref<'left' | 'right'>('left');
const searchKeyword = ref('');
const activeTab = ref<'schedule'>('schedule');
const showLtcsRequestModal = ref(false);

const allBeneficiaryList = ref<Beneficiary[]>([]);
const monthBeneficiaries = ref<Set<string>>(new Set());
const selectedBeneficiary = ref<Beneficiary | null>(null);
const monthlySummary = ref<MonthlySummary[]>([]);
const calendarBeneficiary = ref<Beneficiary | null>(null);
const showCalendarModal = ref(false);

const now = new Date();
const currentYear = now.getFullYear();
const currentMonth = now.getMonth() + 1;

const periodMode = ref<'all' | 'month'>('month');
const { selectedYear, selectedMonth, yearMonth: selectedYM } = useMemberYearMonthOptional(memberCode);

const nextMonthYear = currentMonth === 12 ? currentYear + 1 : currentYear;
const nextMonthMonth = currentMonth === 12 ? 1 : currentMonth + 1;

const canGoPrev = computed(() => {
  return !(selectedYear.value === currentYear - 5 && selectedMonth.value === 1);
});

const canGoNext = computed(() => {
  return !(selectedYear.value === nextMonthYear && selectedMonth.value === nextMonthMonth);
});

const displayPeriodLabel = computed(() => {
  if (periodMode.value === 'all') {
    return '전체 기간';
  }
  return `${selectedYear.value}년 ${selectedMonth.value}월`;
});

const filteredBeneficiaryList = computed(() => {
  let list = allBeneficiaryList.value;

  if (searchKeyword.value) {
    list = list.filter(b => b.patient_name.includes(searchKeyword.value));
  }

  if (periodMode.value === 'month') {
    list = list.filter(b => monthBeneficiaries.value.has(b.patient_code));
  }

  return list;
});

const totalServiceMonths = computed(() => {
  return allBeneficiaryList.value.reduce((sum, b) => sum + (b.total_months || 0), 0);
});

const toggleSidebarPosition = () => {
  sidebarPosition.value = sidebarPosition.value === 'left' ? 'right' : 'left';
};

const setPeriodMode = (mode: 'all' | 'month') => {
  periodMode.value = mode;
  fetchData();
};

const prevMonth = () => {
  if (!canGoPrev.value) return;
  if (selectedMonth.value === 1) {
    selectedYear.value--;
    selectedMonth.value = 12;
  } else {
    selectedMonth.value--;
  }
};

const nextMonth = () => {
  if (!canGoNext.value) return;
  if (selectedMonth.value === 12) {
    selectedYear.value++;
    selectedMonth.value = 1;
  } else {
    selectedMonth.value++;
  }
};

const formatMinutes = (minutes: number | null | undefined): string => {
  if (!minutes) return '0분';
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (hours === 0) return `${mins}분`;
  if (mins === 0) return `${hours}h`;
  return `${hours}h ${mins}m`;
};

const formatYearMonth = (ym: string): string => {
  if (!ym || ym.length !== 6) return ym;
  return `${ym.substring(0, 4)}년 ${parseInt(ym.substring(4))}월`;
};

const formatDateShort = (dateStr: string): string => {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return dateStr;
  return `${date.getFullYear()}.${String(date.getMonth() + 1).padStart(2, '0')}.${String(date.getDate()).padStart(2, '0')}`;
};

const maskCode = (code: string): string => {
  if (!code || code.length < 3) return code || '-';
  return code.slice(0, -3) + '***';
};

const fetchAllBeneficiaries = async () => {
  if (!memberCode.value) return;
  try {
    const res = await homeScheduleApi.getBeneficiaries(memberCode.value, bizGubun.value);
    if (res.data.success) {
      allBeneficiaryList.value = res.data.data || [];
    }
  } catch (error) {
    console.error('전체 수급자 목록 조회 오류:', error);
  }
};

const fetchMonthBeneficiaries = async () => {
  if (!memberCode.value) return;
  try {
    const res = await homeScheduleApi.getBeneficiariesByMonth(memberCode.value, selectedYM.value, bizGubun.value);
    if (res.data.success) {
      const codes = new Set<string>();
      const monthData = res.data.data || [];
      monthData.forEach((b: Beneficiary) => codes.add(b.patient_code));
      monthBeneficiaries.value = codes;
      
      allBeneficiaryList.value = allBeneficiaryList.value.map(ben => {
        const monthInfo = monthData.find((m: Beneficiary) => m.patient_code === ben.patient_code);
        if (monthInfo) {
          return { ...ben, service_days: monthInfo.service_days, total_minutes: monthInfo.total_minutes };
        }
        return ben;
      });
    }
  } catch (error) {
    console.error('월별 수급자 목록 조회 오류:', error);
  }
};

const fetchData = async () => {
  isLoading.value = true;
  try {
    await fetchAllBeneficiaries();
    if (periodMode.value === 'month') {
      await fetchMonthBeneficiaries();
    } else {
      monthBeneficiaries.value = new Set(allBeneficiaryList.value.map(b => b.patient_code));
    }
  } finally {
    isLoading.value = false;
  }
};

const toggleBeneficiary = async (beneficiary: Beneficiary) => {
  if (selectedBeneficiary.value?.patient_code === beneficiary.patient_code) {
    selectedBeneficiary.value = null;
    return;
  }
  selectedBeneficiary.value = beneficiary;
  await fetchMonthlySummary(beneficiary.patient_code);
};

const fetchMonthlySummary = async (patientCode: string) => {
  if (!memberCode.value) return;
  monthlySummaryLoading.value = true;
  try {
    const res = await homeScheduleApi.getBeneficiaryMonthlySummary(memberCode.value, patientCode, bizGubun.value);
    if (res.data.success) {
      monthlySummary.value = res.data.data || [];
    }
  } catch (error) {
    console.error('월별 요약 조회 오류:', error);
    monthlySummary.value = [];
  } finally {
    monthlySummaryLoading.value = false;
  }
};

const printSchedulePdf = async (beneficiary: Beneficiary) => {
  if (!memberCode.value || periodMode.value === 'all') return;
  try {
    const res = await homeScheduleApi.downloadBeneficiaryPdf(memberCode.value, beneficiary.patient_code, selectedYM.value, bizGubun.value);
    const blob = new Blob([res.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `일정표_${beneficiary.patient_name}_${selectedYM.value}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('PDF 다운로드 오류:', error);
    alert('일정표 PDF 다운로드에 실패했습니다.');
  }
};

const printAllBeneficiariesPdf = async () => {
  if (!memberCode.value || periodMode.value === 'all') return;
  
  const count = filteredBeneficiaryList.value.length;
  if (count === 0) {
    alert('출력할 수급자가 없습니다.');
    return;
  }

  if (!confirm(`${selectedYear.value}년 ${selectedMonth.value}월 전체 수급자(${count}명)의 일정표를 PDF로 출력하시겠습니까?`)) {
    return;
  }

  isPdfLoading.value = true;
  try {
    const res = await homeScheduleApi.downloadAllBeneficiariesPdf(memberCode.value, selectedYM.value, bizGubun.value);
    const blob = new Blob([res.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `전체수급자_일정표_${selectedYM.value}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('전체 PDF 다운로드 오류:', error);
    alert('전체 수급자 일정표 PDF 다운로드에 실패했습니다.');
  } finally {
    isPdfLoading.value = false;
  }
};

const onLtcsRequested = () => {
  setTimeout(() => {
    fetchData();
  }, 3000);
};

const openCalendarModal = (beneficiary: Beneficiary) => {
  calendarBeneficiary.value = beneficiary;
  showCalendarModal.value = true;
};

const onCalendarBeneficiaryChange = (beneficiary: Beneficiary) => {
  calendarBeneficiary.value = beneficiary;
};

watch([selectedYear, selectedMonth], () => {
  if (periodMode.value === 'month') {
    fetchMonthBeneficiaries();
  }
});

watch(memberCode, () => {
  if (memberCode.value) {
    fetchData();
  }
});

onMounted(() => {
  if (memberCode.value) {
    fetchData();
  } else {
    isLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["page-layout", { 'sidebar-right': sidebarPosition.value === 'right' }])
    }, [
      _createElementVNode("aside", _hoisted_2, [
        _createElementVNode("button", {
          class: "sidebar-position-toggle",
          onClick: toggleSidebarPosition,
          title: sidebarPosition.value === 'left' ? '우측으로 이동' : '좌측으로 이동'
        }, [
          _createVNode(_component_v_icon, { size: "14" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(sidebarPosition.value === 'left' ? 'mdi-arrow-right' : 'mdi-arrow-left'), 1)
            ]),
            _: 1
          })
        ], 8, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "ym-nav-btn",
            onClick: prevMonth,
            disabled: !canGoPrev.value
          }, [
            _createVNode(_component_v_icon, { size: "18" }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode("mdi-chevron-left", -1)
              ]))]),
              _: 1
            })
          ], 8, _hoisted_5),
          _createElementVNode("div", {
            class: "ym-display",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setPeriodMode('month')))
          }, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(selectedYear)) + "." + _toDisplayString(String(_unref(selectedMonth)).padStart(2, '0')), 1)
          ]),
          _createElementVNode("button", {
            class: "ym-nav-btn",
            onClick: nextMonth,
            disabled: !canGoNext.value
          }, [
            _createVNode(_component_v_icon, { size: "18" }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode("mdi-chevron-right", -1)
              ]))]),
              _: 1
            })
          ], 8, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_v_icon, { size: "14" }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
              _createTextVNode("mdi-account-heart", -1)
            ]))]),
            _: 1
          }),
          _cache[11] || (_cache[11] = _createElementVNode("span", null, "수급자 일정", -1))
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "summary-header" }, [
              _createElementVNode("span", {
                class: "dot",
                style: {"background":"#1e3a5f"}
              }),
              _createElementVNode("span", { class: "label" }, "전체 수급자")
            ], -1)),
            _createElementVNode("span", _hoisted_11, _toDisplayString(allBeneficiaryList.value.length) + "명", 1)
          ]),
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "summary-divider" }, null, -1)),
          _createElementVNode("div", _hoisted_12, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "summary-header" }, [
              _createElementVNode("span", {
                class: "dot",
                style: {"background":"#10b981"}
              }),
              _createElementVNode("span", { class: "label" }, "이번달")
            ], -1)),
            _createElementVNode("span", _hoisted_13, _toDisplayString(monthBeneficiaries.value.size) + "명", 1)
          ]),
          _cache[16] || (_cache[16] = _createElementVNode("div", { class: "summary-divider" }, null, -1)),
          _createElementVNode("div", _hoisted_14, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "summary-header" }, [
              _createElementVNode("span", {
                class: "dot",
                style: {"background":"#6366f1"}
              }),
              _createElementVNode("span", { class: "label" }, "서비스 개월")
            ], -1)),
            _createElementVNode("span", _hoisted_15, _toDisplayString(totalServiceMonths.value) + "개월", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_v_icon, {
              size: "14",
              color: "#64748b"
            }, {
              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                _createTextVNode("mdi-calendar-range", -1)
              ]))]),
              _: 1
            }),
            _cache[18] || (_cache[18] = _createElementVNode("span", null, "기간 선택", -1))
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", {
              class: _normalizeClass(["filter-btn", { active: periodMode.value === 'all' }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (setPeriodMode('all')))
            }, "전체", 2),
            _createElementVNode("button", {
              class: _normalizeClass(["filter-btn", { active: periodMode.value === 'month' }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (setPeriodMode('month')))
            }, _toDisplayString(_unref(selectedMonth)) + "월", 3)
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_v_icon, {
              size: "14",
              color: "#64748b"
            }, {
              default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                _createTextVNode("mdi-magnify", -1)
              ]))]),
              _: 1
            }),
            _cache[20] || (_cache[20] = _createElementVNode("span", null, "수급자 검색", -1))
          ]),
          _createElementVNode("div", _hoisted_21, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "search-input",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchKeyword).value = $event)),
              placeholder: "이름 검색..."
            }, null, 512), [
              [_vModelText, searchKeyword.value]
            ]),
            (searchKeyword.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "search-clear",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (searchKeyword.value = ''))
                }, [
                  _createVNode(_component_v_icon, { size: "12" }, {
                    default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("main", _hoisted_22, [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: "primary",
                size: "48"
              }),
              _cache[22] || (_cache[22] = _createElementVNode("span", null, "데이터를 불러오는 중...", -1))
            ]))
          : (_openBlock(), _createElementBlock("section", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_v_icon, {
                      size: "18",
                      color: "white"
                    }, {
                      default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                        _createTextVNode("mdi-calendar-account", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _cache[24] || (_cache[24] = _createElementVNode("span", { class: "title-text" }, "수급자 일정 목록", -1)),
                  _createElementVNode("span", _hoisted_28, _toDisplayString(filteredBeneficiaryList.value.length) + "명", 1),
                  _cache[25] || (_cache[25] = _createElementVNode("span", { class: "title-badge" }, "일정계획 기준", -1))
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("button", {
                    class: "batch-pdf-btn",
                    onClick: printAllBeneficiariesPdf,
                    disabled: isPdfLoading.value || filteredBeneficiaryList.value.length === 0 || periodMode.value === 'all',
                    title: periodMode.value === 'all' ? '특정 월을 선택해주세요' : '전체 수급자 일정표 PDF 출력'
                  }, [
                    _createVNode(_component_v_icon, { size: "18" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(isPdfLoading.value ? 'mdi-loading mdi-spin' : 'mdi-file-pdf-box'), 1)
                      ]),
                      _: 1
                    }),
                    _cache[26] || (_cache[26] = _createElementVNode("span", null, "전체 일정표 출력", -1))
                  ], 8, _hoisted_30),
                  _createElementVNode("span", _hoisted_31, _toDisplayString(displayPeriodLabel.value) + " 기준", 1)
                ])
              ]),
              (filteredBeneficiaryList.value.length > 0)
                ? (_openBlock(), _createElementBlock("table", _hoisted_32, [
                    _cache[33] || (_cache[33] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { class: "col-no" }, "No"),
                        _createElementVNode("th", null, "수급자명"),
                        _createElementVNode("th", null, "인정번호"),
                        _createElementVNode("th", { class: "text-center" }, "첫 서비스"),
                        _createElementVNode("th", { class: "text-center" }, "최근 서비스"),
                        _createElementVNode("th", { class: "text-center" }, "서비스일/시간"),
                        _createElementVNode("th", { class: "text-center col-action" }, "일정보기"),
                        _createElementVNode("th", { class: "text-center col-action" }, "상세보기"),
                        _createElementVNode("th", { class: "text-center col-action" }, "일정표")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredBeneficiaryList.value, (beneficiary, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: beneficiary.patient_code
                        }, [
                          _createElementVNode("tr", {
                            class: _normalizeClass([{ selected: selectedBeneficiary.value?.patient_code === beneficiary.patient_code }, "beneficiary-row"])
                          }, [
                            _createElementVNode("td", _hoisted_33, _toDisplayString(index + 1), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("div", _hoisted_35, [
                                  _createVNode(_component_v_icon, { size: "12" }, {
                                    default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                                      _createTextVNode("mdi-account", -1)
                                    ]))]),
                                    _: 1
                                  })
                                ]),
                                _createTextVNode(" " + _toDisplayString(beneficiary.patient_name), 1)
                              ])
                            ]),
                            _createElementVNode("td", null, _toDisplayString(maskCode(beneficiary.patient_code)), 1),
                            _createElementVNode("td", _hoisted_36, [
                              _createElementVNode("span", _hoisted_37, _toDisplayString(formatDateShort(beneficiary.first_service_date)), 1)
                            ]),
                            _createElementVNode("td", _hoisted_38, [
                              _createElementVNode("span", _hoisted_39, _toDisplayString(formatDateShort(beneficiary.last_service_date)), 1)
                            ]),
                            _createElementVNode("td", _hoisted_40, [
                              _createElementVNode("span", _hoisted_41, [
                                (periodMode.value === 'month')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(beneficiary.service_days || 0) + "일 / " + _toDisplayString(formatMinutes(beneficiary.total_minutes)), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(beneficiary.total_months || 0) + "개월 ", 1)
                                    ], 64))
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_42, [
                              _createElementVNode("button", {
                                class: "action-btn calendar-btn",
                                onClick: ($event: any) => (openCalendarModal(beneficiary)),
                                title: "일정 캘린더 보기"
                              }, [
                                _createVNode(_component_v_icon, { size: "16" }, {
                                  default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                    _createTextVNode("mdi-calendar-clock", -1)
                                  ]))]),
                                  _: 1
                                })
                              ], 8, _hoisted_43)
                            ]),
                            _createElementVNode("td", _hoisted_44, [
                              _createElementVNode("button", {
                                class: _normalizeClass(["action-btn detail-btn", { active: selectedBeneficiary.value?.patient_code === beneficiary.patient_code }]),
                                onClick: ($event: any) => (toggleBeneficiary(beneficiary)),
                                title: "상세보기"
                              }, [
                                _createVNode(_component_v_icon, { size: "16" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(selectedBeneficiary.value?.patient_code === beneficiary.patient_code ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ], 10, _hoisted_45)
                            ]),
                            _createElementVNode("td", _hoisted_46, [
                              _createElementVNode("button", {
                                class: "action-btn pdf-btn",
                                onClick: ($event: any) => (printSchedulePdf(beneficiary)),
                                disabled: periodMode.value === 'all',
                                title: "일정표 PDF 출력"
                              }, [
                                _createVNode(_component_v_icon, { size: "16" }, {
                                  default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                    _createTextVNode("mdi-file-pdf-box", -1)
                                  ]))]),
                                  _: 1
                                })
                              ], 8, _hoisted_47)
                            ])
                          ], 2),
                          (selectedBeneficiary.value?.patient_code === beneficiary.patient_code)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_48, [
                                _createElementVNode("td", _hoisted_49, [
                                  _createElementVNode("div", _hoisted_50, [
                                    (monthlySummaryLoading.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                          _createVNode(_component_v_progress_circular, {
                                            indeterminate: "",
                                            size: "24"
                                          })
                                        ]))
                                      : (monthlySummary.value.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(monthlySummary.value, (month) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                class: "month-card",
                                                key: month.year_month
                                              }, [
                                                _createElementVNode("div", _hoisted_53, [
                                                  _createElementVNode("span", _hoisted_54, _toDisplayString(formatYearMonth(month.year_month)), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_55, [
                                                  _createElementVNode("div", _hoisted_56, [
                                                    _createElementVNode("div", _hoisted_57, _toDisplayString(month.service_days), 1),
                                                    _cache[30] || (_cache[30] = _createElementVNode("div", { class: "stat-label" }, "서비스일", -1))
                                                  ]),
                                                  _createElementVNode("div", _hoisted_58, [
                                                    _createElementVNode("div", _hoisted_59, _toDisplayString(formatMinutes(month.total_minutes)), 1),
                                                    _cache[31] || (_cache[31] = _createElementVNode("div", { class: "stat-label" }, "총 시간", -1))
                                                  ])
                                                ]),
                                                (month.caregivers)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                                      _createVNode(_component_v_icon, {
                                                        size: "12",
                                                        class: "mr-1"
                                                      }, {
                                                        default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                                                          _createTextVNode("mdi-account-hard-hat", -1)
                                                        ]))]),
                                                        _: 1
                                                      }),
                                                      _createElementVNode("span", null, _toDisplayString(month.caregivers), 1)
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            }), 128))
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_61, "서비스 이력 데이터가 없습니다"))
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _createVNode(_component_v_icon, { size: "48" }, {
                        default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                          _createTextVNode("mdi-calendar-account-outline", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _cache[37] || (_cache[37] = _createElementVNode("div", { class: "empty-text" }, "일정계획 데이터가 없습니다", -1)),
                    _cache[38] || (_cache[38] = _createElementVNode("div", { class: "empty-hint" }, " 롱텀케어에서 일정계획 데이터를 가져오세요 ", -1)),
                    _createElementVNode("button", {
                      class: "empty-request-btn",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (showLtcsRequestModal.value = true))
                    }, [
                      _createVNode(_component_v_icon, { size: "18" }, {
                        default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                          _createTextVNode("mdi-cloud-download", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[36] || (_cache[36] = _createElementVNode("span", null, "일정계획 데이터 요청", -1))
                    ])
                  ]))
            ]))
      ])
    ], 2),
    _createVNode(LtcsRequestModal, {
      modelValue: showLtcsRequestModal.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showLtcsRequestModal).value = $event)),
      "default-year-month": _unref(selectedYM),
      "member-code": memberCode.value,
      "biz-gubun": bizGubun.value,
      onRequested: onLtcsRequested
    }, null, 8, ["modelValue", "default-year-month", "member-code", "biz-gubun"]),
    _createVNode(BeneficiaryCalendarModal, {
      modelValue: showCalendarModal.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showCalendarModal).value = $event)),
      beneficiary: calendarBeneficiary.value,
      beneficiaries: filteredBeneficiaryList.value,
      "member-code": memberCode.value,
      "biz-gubun": bizGubun.value,
      year: _unref(selectedYear),
      month: _unref(selectedMonth),
      onChangeBeneficiary: onCalendarBeneficiaryChange
    }, null, 8, ["modelValue", "beneficiary", "beneficiaries", "member-code", "biz-gubun", "year", "month"])
  ]))
}
}

})